export default __webpack_public_path__ + "static/media/Footpad's Mask of the Final Way.e5426845.jpg";